var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTwitter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.3319 7.85148L15.5437 1.5H14.3087L9.78327 7.0149L6.16883 1.5H2L7.46574 9.8395L2 16.5H3.2351L8.01406 10.6761L11.8312 16.5H16L10.3316 7.85148H10.3319ZM8.64026 9.91297L8.08647 9.08255L3.68013 2.47476H5.57717L9.13314 7.80746L9.68693 8.63788L14.3093 15.5696H12.4122L8.64026 9.91329V9.91297Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.fa9a25f1b1b86056599608dc234098ea.svg";
export { ForwardRef as ReactComponent };